var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"bg-white w-100 p-3"},[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5 col-md-6 col-lg-6"},[_c('ul',{staticClass:"list-inline mb-0 left-text"},[_vm._t("left")],2)]),_c('div',{staticClass:"col-sm-7 col-md-6 col-lg-6 text-right text-right"},[_vm._t("right")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }